import { render, staticRenderFns } from "./CrUpdated.vue?vue&type=template&id=6bb94f3b"
import script from "./CrUpdated.vue?vue&type=script&lang=js"
export * from "./CrUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports